import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Layout, PageHeader } from "@/components/Layout";
import { AlertTriangle } from "lucide-react";

export default function Errors() {
  const { data: errors = [] } = useQuery({
    queryKey: ["errors"],
    queryFn: async () => (await api.get("/admin/errors")).data,
    refetchInterval: 8000,
  });

  return (
    <Layout>
      <PageHeader title="Registro de Errores" subtitle="Fallos de procesamiento y excepciones" />
      <div className="p-8 space-y-3">
        {errors.map((e) => (
          <div key={e.id} data-testid={`error-row-${e.id}`} className="rounded-lg border p-4"
            style={{ backgroundColor: "#111827", borderColor: "#7F1D1D" }}>
            <div className="flex items-center justify-between mb-2">
              <span className="flex items-center gap-2 text-rose-400 text-sm font-medium">
                <AlertTriangle className="w-4 h-4" /> {e.source}
              </span>
              <span className="text-xs text-slate-500 font-mono">{e.created_at?.slice(0, 19)}</span>
            </div>
            <div className="text-sm text-slate-300">{e.message}</div>
            <div className="flex gap-4 mt-2 text-xs text-slate-500 font-mono">
              {e.job_id && <span>JOB: {e.job_id}</span>}
              {e.telegram_id && <span>USER: {e.telegram_id}</span>}
            </div>
            {e.trace && (
              <details className="mt-2">
                <summary className="text-xs text-slate-500 cursor-pointer">Ver traza</summary>
                <pre className="text-[10px] text-slate-500 mt-2 overflow-x-auto whitespace-pre-wrap">{e.trace}</pre>
              </details>
            )}
          </div>
        ))}
        {errors.length === 0 && <div className="text-center text-slate-500 py-12">Sin errores registrados ✓</div>}
      </div>
    </Layout>
  );
}
